module.exports = __webpack_public_path__ + "static/media/ck.22bf8119.svg";